import getInstance from "./Request";

export const getDriverLogsAdmin = async (params) => {
    const request = await getInstance();
    let data = await request
        .get("/admin/driver-logs", { params })
        .catch((error) => {
            return {
                error,
            };
        });
    return data;
};
